import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/views/layout/Layout'

/** note: submenu only apppear when children.length>=1
 *   detail see  https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 **/

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']     will control the page roles (you can set multiple roles)
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
    noCache: true                if true ,the page will no be cached(default is false)
  }
 **/
export const constantRouterMap = [
  { path: '/login', component: () => import('@/views/login/index'), hidden: true ,meta:{chineseName:' 工作台-首页',title:'登录页'}},
  { path: '/', component: () => import('@/views/home/index'), hidden: true ,requireAuth: true,meta:{chineseName:' 工作台-首页',title:'工作台-首页'}},
  { path: '/404', component: () => import('@/views/errorPage/404'), hidden: true },
  { path: '/liveTV', component: () => import('@/views/live/livePlay'), hidden: true },
  { path: '/guidePages', component: () => import('@/views/guidepages/index'), hidden: true },
  {
    name: 'privacy', path: '/privacy', component: () => import('@/views/privacy/index'), hidden: true
  },
  {
    name: 'scanTheQRCodeToSignIn', path: '/scanTheQRCodeToSignIn', component: () => import('@/views/meetingRoom/scanTheQRCodeToSignIn/index'), hidden: true,
    meta: { title: 'scanTheQRCodeToSignIn',noCache: false,chineseName:'扫码签到'},
  },
  {
    name: 'signSuccess', path: '/signSuccess', component: () => import('@/views/meetingRoom/scanTheQRCodeToSignIn/signSuccess'), hidden: true
  },
  {
    name: 'tianwayun', path: '/tianwayun', component: () => import('@/views/tianwayun/index'), hidden: true
  },
  // { path: '/devices', component: () => import('@/views/devices/index'), hidden: true },
  {
    path: '',
    component: Layout,
    redirect: 'devices',
    children: [{
      path: 'devices',
      component: () => import('@/views/devices/index'),
      name: 'devices',
      meta: { title: 'Devices', icon: 'device',requireAuth: true,chineseName:'工作台-设备控制'}
    }]
  },
  {
    path: '',
    component: Layout,
    redirect: 'broadcast',
    children: [{
      path: 'broadcast',
      component: () => import('@/views/broadcast/index'),
      name: 'broadcast',
      meta: { title: 'Broadcast', icon: 'broadcast',requireAuth: true ,chineseName:'工作台-广播控制'}
    }]
  },
  {
    path: '',
    component: Layout,
    redirect: 'schedule',
    children: [{
      path: 'schedule',
      component: () => import('@/views/schedule/index'),
      name: 'schedule',
      meta: { title: 'Schedule', icon: 'schedule',requireAuth: true ,chineseName:'工作台-日程任务'}
    }]
  },
  {
    path: '',
    component: Layout,
    redirect: 'resources',
    children: [{
      path: 'resources',
      component: () => import('@/views/resources/index'),
      name: 'resources',
      meta: { title: 'Resources', icon: 'resources',requireAuth: true,chineseName:'工作台-云盘管理' }
    }]
  },
  {
    path: '',
    component: Layout,
    redirect: 'live',
    children: [{
      path: 'live',
      component: () => import('@/views/live/index'),
      name: 'live',
      meta: { title: 'Live', icon: 'live' ,requireAuth: true ,chineseName:'工作台-直播控制'}
    }]
  },
  {
    path: '',
    component: Layout,
    redirect: 'meetingRoom',
    children: [{
      path: 'meetingRoom',
      component: () => import('@/views/meetingRoom/index'),
      name: 'meetingRoom',
      meta: { title: 'meetings', icon: 'meetingRoom' ,requireAuth: true ,chineseName:'工作台-会议预约'}
    }]
  },
  {
    path: '',
    component: Layout,
    redirect: 'updates',
    children: [{
      path: 'updates',
      component: () => import('@/views/lastestUpdates/index'),
      name: 'updates',
      meta: { title: 'updates', icon: 'updates' ,requireAuth: true ,chineseName:'版本更新'},
      hidden: true
    }]
  },
  {
    path: '',
    component: Layout,
    // redirect: 'user',
    children: [{
      path: 'user',
      component: () => import('@/views/user/index'),
      name: 'user',
      meta: { title: 'information',requireAuth: true, icon: 'information',noCache: false,chineseName:'工作台-个人资料'},
      hidden: true
    }]
  },
  {
    path: '',
    component: Layout,
    // redirect: 'user',
    children: [{
      path: 'information',
      component: () => import('@/views/information/index'),
      name: 'information',
      meta: { title: 'information',requireAuth: true, icon: 'information',noCache: false,chineseName:'工作台-查看全部消息'},
      hidden: true
    }]
  },
  // { path: '',component: Layout ,component: () => import('@/views/user/index'), name: 'user' }
  // {
  //   name:'devices',
  //   routes: {
  //     path: '/devices',
  //     component: 'Layout',
  //     children: [{
  //       path: 'devices',
  //       component: '/devices/index',
  //       name: 'devices',
  //       meta: {title: 'devices', icon: 'groups', noCache: true},
  //       setName: 'devices'
  //     }]
  //   }
  //   },
]

export default new Router({
  mode: 'history', // require service support
  base: "/console/",
  scrollBehavior: () => ({ y: 0 }),
  // base:'/IQControl/',
  routes: constantRouterMap
})
export const asyncRouterMap = []
export const routesModule = [
  {
    name:'V3_0_OrgChildManage',
    routes:{
      path: '',
      component: 'Layout',
      children: [{
        path: 'organizationMge',
        component: '/organizationMge/index',
        name: 'organizationMge',
        meta: { title: 'organizationMge',requireAuth: true, icon: 'groups', noCache: true,chineseName:'管理后台-组织管理'},
        setName:'V3_0_OrganizationManage'
      }]
    },
  },
  {
    name:'V3_0_OrganizationManage',
    routes: {
      path: '',
      component: 'Layout',
      children: [{
        path: 'organizationShoolIndexMge',
        component: '/organizationMge/shoolIndex',
        name: 'organizationShoolIndexMge',
        meta: { title: 'organizationMge',requireAuth: true, icon: 'groups', noCache: true,chineseName:'管理后台-组织管理' },
        setName:'V3_0_OrganizationManage1'
      }]
    },
  },
  {
    name:'V3_0_UserManage',
    routes:{
      path: '',
      component: 'Layout',
      children: [{
        path: 'userMge',
        component: '/userMge/index',
        name: 'userMge',
        meta: { title: 'userMge',requireAuth: true, icon: 'user', noCache: true,chineseName:'管理后台-用户管理' },
        setName:'V3_0_UserManage'
      }]
    },
  },
  // {
  //   name:'V3_0_AuthorityMge',
  //   routes:{
  //     path: '',
  //     component: 'Layout',
  //     redirect: 'authorityMge',
  //     name: 'authorityMge',
  //     // meta: {
  //     //   title: 'authorityMge',
  //     //   icon: 'permission',
  //     // },
  //     setName:'V3_0_AuthorityMge',
  //     children: [
  //       { path: 'authorityMge', component: '/authorityMge/index', name: 'authorityMge', meta: { title: 'roleMge',requireAuth: true,icon: 'permission',chineseName:'管理后台-角色权限管理'  }},
  //       // { path: 'card', component: '/authorityMge/card', name: 'cardMge', meta: { title: 'cardMge' }}
  //     ]
  //   },
  // },

  {
    name:'V3_0_DeviceManage',
    routes:{
      path: '',
      component: 'Layout',
      meta: { title: 'equipmentMge', icon: 'devices', noCache: true },
      setName:'V3_0_DeviceManage',
      children: [{
        path: 'processorManager',
        component: '/equipmentMge/index',
        name: 'processorManager',
        meta: { title: 'processorManager',requireAuth: true,chineseName:'管理后台-设备管理'}
      },
        { path: 'repairLog', component: '/repairLog/index', name: 'repairLog', meta: { title: 'RepairLog',requireAuth: true,chineseName:'管理后台-报修日志'},setName:'V3_0_DeviceManage_RepairLog'},
        { path: 'projectorCode', component: '/projectorDevices/index', name: 'projectorCode', meta: { title: 'projectorCode',requireAuth: true,chineseName:'管理后台-摄影机码管理'},setName:'V3_0_DeviceManage_AddDevice'},
        { path: 'acCode', component: '/acCode/index', name: 'acCode', meta: { title: 'acCode',chineseName:'管理后台-空调码管理'},setName:'V3_0_DeviceManage_RepairLog'},
        { path: 'remoteControl', component: '/remoteControl/index', name: 'remoteControl', meta: { title: 'remoteControl',chineseName:'管理后台-智能遥控码管理'},setName:'V3_0_DeviceManage_RepairLog'},
        // { path: 'interfaceRename', component: '/equipmentMge/editName', name: 'interfaceRename', meta: { title: 'interfaceRename',requireAuth: true,chineseName:'管理后台-接口重命名'},setName:'V3_0_DeviceManage_AddDevice'},
        // { path: 'interfaceRename', component: '/equipmentMge/editName', name: 'interfaceRename', meta: { title: 'interfaceRename',requireAuth: true},setName:'V3_0_DeviceManage_AddDevice'},
        { path: 'Automation', component: '/equipmentMge/Automation', name: 'Automation', meta: { title: 'Automation',chineseName:'管理后台-设备管理-自动化控制'},setName:'V3_0_DeviceManage_AddDevice'},
        // { path: 'InputSourcesLinkage', component: '/equipmentMge/InputSourcesLinkage', name: 'InputSourcesLinkage', meta: { title: 'InputSourcesLinkage',chineseName:'管理后台-设备管理-输入源切换联动'},setName:'V3_0_DeviceManage_AddDevice'},
      ]
    },
  },
  {
    name:'V3_0_CardManageCenter',
    routes:{
      path: '',
      component: 'Layout',
      // redirect: 'cardMge',
      name: 'cardMge',
      meta: { title: 'cardMge', icon: 'card', noCache: true },
      setName:'V3_0_CardManageCenter',
      children: [
        {
          path: 'CardMge',
          component: '/cardMge/index',
          name: 'CardMge1',
          meta: { title: 'cardManager',chineseName:'管理后台-卡管理'}
        },
        { path: 'cardLog', component: '/cardMge/cardLog', name: 'cardLog', meta: { title: 'cardLog',chineseName:'管理后台-卡管理日志'},setName:'V3_0_CardManageCenter_RepairLog'}

      ]
    },
  },
  {
    name: 'V3_0_CardManageCenter',
    routes: {
      path: '',
      name: "meetings",
      component: 'Layout',
      // redirect: 'cardMge',
      meta: {title: 'meetingManager', icon: 'meeting', noCache: true},
      setName: 'V3_0_CardManageCenter',
      children: [
        {
          path: 'MeetMge',
          component: '/meetings/index',
          name: 'meetingRoomManager',
          meta: {title: 'meetingRoomManager', chineseName: '管理后台-会议管理-会议室管理'}
        },
        {
          path: 'MeetDoorMge',
          component: '/meetings/MeetDoor',
          name: 'meetingDoorManager',
          meta: {title: 'meetingDoorManager', chineseName: '管理后台-会议管理-会议室门牌管理'},
          setName: 'V3_0_CardManageCenter_RepairLog'
        }

      ]
    },
  },
  {
    name:'V3_0_IQManageCenter_MediaDeviceManage',
    routes:{
      path: '',
      component: 'Layout',
      children: [{
        path: 'workstationMge',
        component:  '/workstationMge/index',
        name: 'workstationMge',
        meta: { title: 'workstationMge', icon: 'mediastation', noCache: true ,requireAuth: true,chineseName:'管理后台-媒体工作站管理'}
      }]
    },
  },
  {
    name:'V3_0_IQManageCenter_CloudSpaceManage',
    routes:{
      path: '',
      component: 'Layout',
      name: 'cloudDiskMge',
      children: [
        { path: 'cloudDiskMge', component:  '/cloudDiskMge/index', name: 'cloudDiskMge', meta: { title: 'cloudDiskMge',icon: 'clouddrive',requireAuth: true,chineseName:'管理后台-云盘管理'  }},
        // { path: 'storageMge', component: () => import('@/views/cloudDiskMge/storageMge'), name: 'storageMge', meta: { title: 'storageMge' }}
      ]
    },
  },
  // {
  //   name:'V3_0_IQManageCenter_LoggerManage',
  //   routes:{
  //     path: '',
  //     component: 'Layout',
  //     children: [{
  //       path: 'operationLog',
  //       component: '/operationLog/index',
  //       name: 'operationLog',
  //       meta: { title: 'operationLog', icon: 'operationlog', noCache: true }
  //     }]
  //   }
  // },
  {
    name: 'V3_0_IQManageCenter_Setting',
    routes: {
      path: '',
      component: 'Layout',
      children: [{
        path: 'customize',
        component: '/customize/index',
        name: 'customize',
        meta: {title: 'customize', icon: 'customize', noCache: true, chineseName: '管理后台-自定义'}
      }]
    }
  },
  {
    name:'V3_0_IQManageCenter_Setting',
    routes:{
      path: '',
      component: 'Layout',
      children: [{
        path: 'setting',
        component: '/setting/index',
        name: 'setting',
        meta: { title: 'setting', icon: 'setting', noCache: true,requireAuth: true,chineseName:'管理后台-系统设置'}
      }]
    }
  },



]



// WEBPACK FOOTER //
// ./src/router/index.js